import { render, staticRenderFns } from "./creation.vue?vue&type=template&id=0c179634&scoped=true"
import script from "./creation.vue?vue&type=script&lang=js"
export * from "./creation.vue?vue&type=script&lang=js"
import style0 from "./creation.vue?vue&type=style&index=0&id=0c179634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c179634",
  null
  
)

export default component.exports